/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.filas': 'Filas',
'filas.agregarFilas': 'Create Filas',
'filas.modificarFilas': 'Edit Filas',
'filas.eliminarFilas': 'Delete Filas',
'filas.filaId': 'Fila   Id ',
'filas.empresaId': ' Empresa   Id ',
'filas.descripcionFila': ' Descripcion   Fila',
'filas.filas': 'Filas',
'filas.verFilas': 'View Filas',
};

